module.exports = __webpack_public_path__ + "img/three_six.a5ccfb81.png";